<!-- <div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
        <img src="logo.png" alt="Image" height="50" class="mb-3" />
        <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, #9194ff 0%, #f47f46 100%);">
            <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center" style="border-radius:53px">
                <span class="text-blue-500 font-bold text-3xl">Sin servicio</span>
                <h1 class="text-900 font-bold text-3xl lg:text-5xl mb-2">Ventana de mantenimiento</h1>
                <div class="text-600 mb-5">Por el momento no se puede realizar ninguna operación, favor de intentarlo más tarde</div>
            </div>
        </div>
    </div>
</div> -->

<div *ngIf="updateAvailable" class="version-update-banner">
  <span class="pi pi-refresh" style="margin-right: 8px;"></span>
  <span>Hay una nueva versión disponible.</span>
  <button (click)="reloadPage()" class="version-update-btn">Actualizar ahora</button>
</div>

<div class="app-layout" *ngIf="showMenu; else noMenu"
     [class.sidebar-collapsed]="sidebarCollapsed"
     [class.mobile-open]="mobileOpen">

  <!-- Mobile topbar -->
  <header class="mobile-topbar">
    <button class="hamburger" (click)="toggleMobile()" aria-label="Abrir menú">
      <i class="pi" [ngClass]="mobileOpen ? 'pi-times' : 'pi-bars'"></i>
    </button>
    <img src="logo.png" alt="Logo" height="28" />
  </header>

  <!-- Backdrop (mobile only) -->
  <div class="sidebar-backdrop" (click)="closeMobile()"></div>

  <!-- Sidebar -->
  <aside class="app-sidebar">
    <div class="sidebar-logo">
      <img src="logo.png" alt="Logo" height="36" *ngIf="!sidebarCollapsed" />
      <button class="sidebar-toggle" (click)="toggleSidebar()"
              [title]="sidebarCollapsed ? 'Expandir menú' : 'Colapsar menú'">
        <i class="pi" [ngClass]="sidebarCollapsed ? 'pi-chevron-right' : 'pi-chevron-left'"></i>
      </button>
    </div>

    <nav class="sidebar-nav">
      <ng-container *ngFor="let item of items">

        <!-- Group item (has subitems) -->
        <ng-container *ngIf="item.items && item.items.length; else flatItem">
          <div class="nav-item nav-group-header"
               [class.nav-group-active]="isChildActive(item)"
               (click)="toggleGroup(item.label || '')"
               [title]="sidebarCollapsed ? item.label || '' : ''">
            <span class="nav-icon-wrap" [style.background]="getNavColor(item).bg">
              <i [ngClass]="item.icon" [style.color]="getNavColor(item).icon"></i>
            </span>
            <span class="nav-label" *ngIf="!sidebarCollapsed">{{ item.label }}</span>
            <i *ngIf="!sidebarCollapsed" class="nav-chevron pi pi-chevron-down"
               [style.transform]="isGroupExpanded(item.label || '') ? 'rotate(-180deg)' : 'rotate(0deg)'"></i>
          </div>
          <div *ngIf="isGroupExpanded(item.label || '') && !sidebarCollapsed" class="nav-subitems">
            <a *ngFor="let sub of item.items"
               [routerLink]="sub.routerLink"
               routerLinkActive="nav-item-active"
               class="nav-item nav-subitem">
              <span class="nav-icon-wrap" [style.background]="getNavColor(sub).bg">
                <i [ngClass]="sub.icon" [style.color]="getNavColor(sub).icon"></i>
              </span>
              <span class="nav-label">{{ sub.label }}</span>
            </a>
          </div>
        </ng-container>

        <!-- Flat item -->
        <ng-template #flatItem>
          <a [routerLink]="item.routerLink"
             routerLinkActive="nav-item-active"
             [routerLinkActiveOptions]="{ exact: item.routerLink?.[0] === '/dashboard/home' }"
             class="nav-item"
             [title]="sidebarCollapsed ? item.label || '' : ''">
            <span class="nav-icon-wrap" [style.background]="getNavColor(item).bg">
              <i [ngClass]="item.icon" [style.color]="getNavColor(item).icon"></i>
            </span>
            <span class="nav-label" *ngIf="!sidebarCollapsed">{{ item.label }}</span>
          </a>
        </ng-template>

      </ng-container>
    </nav>

    <div class="sidebar-footer">
      <a [routerLink]="['/auth/logout']" class="nav-item nav-item-logout"
         [title]="sidebarCollapsed ? 'Cerrar Sesión' : ''">
        <i class="pi pi-sign-out nav-icon"></i>
        <span class="nav-label" *ngIf="!sidebarCollapsed">Cerrar Sesión</span>
      </a>
    </div>
  </aside>

  <!-- Main content -->
  <main class="app-main">
    <p-toast position="top-right" key="global"></p-toast>
    <router-outlet></router-outlet>
  </main>
</div>

<ng-template #noMenu>
  <p-toast position="top-right" key="global"></p-toast>
  <router-outlet></router-outlet>
</ng-template>
